module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkuNDYgNS4xNUwxLjYwNC4xMTlDMS4zNzMtLjAyMiAxLjA4NSAwIC44NjcgMC0uMDAzLjAwMSAwIC42ODUgMCAuODU4djEwLjI4NGMwIC4xNDYtLjAwNC44NTcuODY3Ljg1Ny4yMTggMCAuNTA2LjAyMy43MzgtLjExOGw3Ljg1NC01LjAzYy42NDUtLjM5LjUzNC0uODUxLjUzNC0uODUxcy4xMTEtLjQ2LS41MzQtLjg1eiIgZmlsbD0iIzAzMDBFMiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-play.svg
// module id = 4HFS
// module chunks = 0